module.exports = __webpack_public_path__ + "img/profile.0173529b.svg";